import React from 'react';
import { mapModifiers } from 'libs/component';
import Default from 'components/templates/default';
import { Heading } from 'components/atoms/heading';
import { Text } from 'components/atoms/text';
import { Section } from 'components/molecules/section';
import { ContactForm } from 'components/organisms/contact-form';
// import { ContactInfo } from 'components/organisms/contact-info';
// import { ContactInfoItem } from 'components/molecules/contact-info-item';
// import { Map } from 'components/organisms/map';
import { useTranslation } from 'react-i18next';
import Lottie from 'lottie-react';
import loadingLottieFile from 'lotties/loader.json';

const heroImage = '/images/hero-banners/contact-us.jpg';
const heroImageSp = '/images/hero-banners/contact-us-sp.jpg';

export interface ContactUsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit?: (data: any) => void;
  isSubmitting?: boolean;
}

export const ContactUs: React.FC<ContactUsProps> = ({ onSubmit, isSubmitting = false }) => {
  const { t } = useTranslation();

  return (
    <div className={mapModifiers('t-contact-us')}>
      <Default heroImage={heroImage} heroImageSp={heroImageSp}>
        <Heading>{t('contact.title')}</Heading>
        <Section className="t-contact-us__top">
          <h2>{t('contact.description')}</h2>
          <Text>{t('contact.address')}</Text>
        </Section>
        <Section className="t-contact-us__form">
          {isSubmitting && (
            <div className="t-contact-us__form-loading">
              <div className="t-contact-us__form-loading-icon">
                <Lottie animationData={loadingLottieFile} />
              </div>
            </div>
          )}
          <ContactForm onSubmit={onSubmit} />
        </Section>
        {/* <Section className="t-contact-us__list">
          <ContactInfo>
            <ContactInfoItem
              icon="briefcase"
              title={t('contact.sales.title')}
              tel="(662) 229 3311"
              email="sales@qsncc.com"
              description={t('contact.sales.description')}
            />
            <ContactInfoItem
              icon="megaphone"
              title={t('contact.press.title')}
              tel="(662) 229 3082"
              email="press@qsncc.com"
              description={t('contact.press.description')}
            />
          </ContactInfo>
        </Section> */}
        {/* <Section className="t-contact-us__map">
          <Map />
        </Section> */}
      </Default>
    </div>
  );
};
